(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Timeline"] && !Shopify.designMode) return;
  try {
    
setTimeout(function () {
  jQuery('.wp-tabs .wp-tab-wrap .wp-tab-panel:first-child').show();
    jQuery('.tab-view .wp-tabs-nav li:first-child').addClass('current');
  jQuery('.wp-tabs-nav li').bind('click', function (e) {
    $this = jQuery(this);
    $target = jQuery($this.data("target"));
    $this.siblings().removeClass('current');
    $target.siblings().css("display", "none");
    $this.addClass('current');
    $target.fadeIn("fast");
  });
   }, 20);
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  setTimeout(function () {
    var $banner = jQuery('.main-banner');

    if (!$banner.length || typeof $banner.owlCarousel !== 'function') {
      return;
    }

    $banner.each(function () {
      var $currentBanner = jQuery(this);

      if ($currentBanner.hasClass('owl-loaded')) {
        return;
      }

      $currentBanner.owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        responsiveClass: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        smartSpeed: 700,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        responsive: {
          0: {
            items: 1,
            nav: false,
            dots: true
          },
          600: {
            items: 1,
            nav: false,
            dots: true
          },
          1000: {
            items: 1,
            nav: false,
            dots: true
          }
        }
      });
    });
  }, 60);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
       setTimeout(function () {
          
          jQuery(".faq-block").find(".title-block").click(function () {
          jQuery(this).next().toggleClass("open").slideToggle("fast");
           
          
          jQuery(this).toggleClass("active-tab").find(".content-link").toggleClass("active");
  
          jQuery(".accordion-content").not(jQuery(this).next()).slideUp("fast").removeClass("open");
          jQuery(".title-block").not(jQuery(this)).removeClass("active-tab").find("content-link").removeClass("active");
          });
          }, 55);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-owl-carousel"] && !Shopify.designMode) return;
  try {
    
     setTimeout(function () {

jQuery('.featured-slider').owlCarousel({ 
    loop:true,
    margin:20,
    nav:false,
    dots:false,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
               nav:false,
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:4,
            nav:true,
            loop:false
        }
    }
})
     const $referenceElement = jQuery(".page-width");
    const $targetElement = jQuery(".featured-slider .owl-dots");
    const marginLeft = $referenceElement.css("margin-left");
    $targetElement.css("margin-left", marginLeft);


     }, 60);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const toggleButtons = document.querySelectorAll(".toggle-btn");
    const container = document.querySelector("#ProductGridContainer");
    function setActiveButton(button) {
        toggleButtons.forEach(function (btn) {
            btn.classList.remove("active");
        });
        button.classList.add("active");
        const mode = button.getAttribute("data-mode");
        container.setAttribute("data-view-mode", mode);
    }
    const initialActiveButton = toggleButtons[3]; // Index 3 corresponds to the fourth button
    toggleButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
            e.preventDefault();
            setActiveButton(button);
        });
    });
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-newsletter"]) return;
  try {
    
  var popupClosed = localStorage.getItem('popupClosed');
  if (!localStorage.getItem('popupShown') && !popupClosed) {
      setTimeout(function() {
          document.getElementById('promo-modal').classList.add('is-visible');
      }, 4000);
      localStorage.setItem('popupShown', 'true');
  }

  document.querySelectorAll('.modal-close').forEach(function(element) {
      element.addEventListener('click', function() {
          document.getElementById('promo-modal').classList.remove('is-visible');
          localStorage.setItem('popupClosed', 'true');
      });
  });

  document.querySelectorAll('.modal-overlay').forEach(function(element) {
      element.addEventListener('click', function() {
          document.getElementById('promo-modal').classList.remove('is-visible');
          localStorage.setItem('popupClosed', 'true');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonails"] && !Shopify.designMode) return;
  try {
    
     setTimeout(function () {



 
     jQuery('.owl-carousel').each(function(index) {
      var $carousel = $(this);
      var carouselID = 'owl-carousel-' + $carousel.attr('id');
      var autoplay = true;
      var loop = false;
      var items = 3;
      var dots_active = true;
      
      // Set the options for the Owl Carousel
      var options = {
        autoplay: false,
        loop: true,
        items: items,
         center: true,
        dots:dots_active,
         responsive:{
          0:{
              items:1,
              margin:5,
          },
          600:{
              items:2,
             margin:5,
          },
          1000:{
              items:3,
              autoplay: false,
              margin:30,
             center: true,
             dots:true,
          }
      }
      };

      $carousel.owlCarousel(options);
    });


 
}, 60);

  } catch(e) { console.error(e); }
})();
})();
